import type { LifecycleEventResult } from '../data/sessions-repository'

type Listener = (result: LifecycleEventResult) => void

const listeners = new Set<Listener>()

/**
 * Lifecycle results written OUTSIDE the session screen (the app-wide session
 * call recorder) — the open sessions list patches its row from these, exactly
 * like its own `onResult`.
 */
export function publishSessionLifecycleResult(result: LifecycleEventResult): void {
  for (const listener of listeners) listener(result)
}

export function subscribeSessionLifecycleResults(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
